import { useQuery } from '@tanstack/react-query';
import { factoryGetPublicConsentKey } from '../factories/queries';
import { ConsentsService } from '../services';
import type { IOfficeConsentContent } from '../types/OfficeConsentContent';
import type { IGetPublicConsentParameters } from '../types/PublicConsent.parameters';

interface IUseGetPublicConsentOptions {
  enable?: boolean;
}

export const useGetPublicConsent = (
  params: IGetPublicConsentParameters,
  options: IUseGetPublicConsentOptions = {},
) => {
  const { enable = true } = options;

  const { data, error, isError, isLoading, isFetching, refetch } =
    useQuery<IOfficeConsentContent>({
      queryKey: factoryGetPublicConsentKey(params),
      queryFn: () => ConsentsService.getPublicConsent(params),
      refetchOnWindowFocus: false,
      retry: false,
      enabled: enable,
    });

  return {
    data,
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
    refetch,
  };
};
